import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ListInterface } from 'src/app/Inteface/list-interface';
import { ConfirmDialogModel, DialogComponent } from '../../dialog/dialog.component';
import { MatDialog } from '@angular/material';
import { log } from 'util';
import { AddElementComponent } from '../../add-element/add-element.component';
import { SharedService } from '../../../Services/shared.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { CodeLinkageService } from 'src/app/Services/code-linkage.service';


@Component({
  selector: 'ze-object-list-main',
  templateUrl: './object-list-main.component.html',
  styleUrls: ['./object-list-main.component.scss']
})
export class ObjectListMainComponent implements OnInit {
  @Input("listInteface") list: ListInterface;
  filter = "name:";
  @Input("active") active: boolean;
  @Input("showStep") showStep: boolean = false;
  mode: string;
  heading: string;
  modelLabel: string;
  addAvailable: boolean;
  @Input() viewComponent: any;
  constructor(
    public dialog: MatDialog,
    private _sharedService: SharedService,
    private notifys: NotifyService,
    private codeLinkageService: CodeLinkageService
  ) {
  }
  ngOnInit() {
    this.heading = this.list.mainHeadingName;
    this.list.listItemHeadingProperyName = "name";
    this.filter = this.list.listItemHeadingProperyName + ":";
    this.addAvailable = (this.list.modelService != undefined && this.list.modelService.addNew != undefined);
  }
  ngOnChanges(changes: SimpleChanges) {
  }
  searchQuery(event: any) {
    let source = event.srcElement as HTMLInputElement;
    this.filter = "name:" + source.value;
  }
  clearFilter() {
    this.filter = '';
  }
  getListName(): string[] {
    return this.list.models.map(item => item['name']);
  }
  addModel(event: any, formData: any = {}) {
    try {
      let jiratitle = '';
      if (this.list.mainHeadingName === 'Suites') {
        jiratitle = 'epic';
      } else if (this.list.mainHeadingName === 'Scenario') {
        jiratitle = 'user story';
      }
      let dialogRef = this.dialog.open(AddElementComponent,
        {
          data: {
            event: event,
            list: this.getListName(),
            title: event + this.list.mainHeadingName,
            name: ((event=="Save As ")?this.makeNameUniqueInList(formData.name, this.getListName()):formData.name)
          }
        });
      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          // if (event != null) {
          //   event.preventDefault();
          //   event.target.blur();
          // }
          let instance = this;
          if (dialogResult != undefined) {
            if (event == "Edit ") {
              this._sharedService.loaderHide.emit(true)
              formData.name = dialogResult.name
              
              console.log('Dialog Result:', dialogResult);
              console.log('Form Data:', formData);
              
              // Pass the mapping data to the edit method
              const mappingData = {
                projectEpicMappingModel: dialogResult.projectEpicMappingModel,
                projectScenarioMappingModel: dialogResult.projectScenarioMappingModel
              };
              
              instance.list.modelService.edit(formData, mappingData).subscribe((data) => {
                console.log('Edit API Response:', data);
                this.updateArtifactNameInArtifactAssociations(formData.name, formData._type, formData._id);
                instance.addAndGet(instance.viewComponent, instance.list.modelService.constructor.name);
                this._sharedService.loaderHide.emit(false)
                this.notifys.notify('success', 'Success', "Updated Successfully");
              }, error => {
                console.error('Edit API Error:', error);
                this._sharedService.loaderHide.emit(false)
                this.notifys.notify('error', 'Error', error);
              });
            }
            else if (event == "Save As ") {
              console.log("List:",this.getListName());
              this._sharedService.loaderHide.emit(true)
              formData.name = dialogResult.name
              instance.list.modelService.saveAsModel(formData).subscribe((data) => {
                instance.addAndGet(instance.viewComponent, instance.list.modelService.constructor.name);
                this._sharedService.loaderHide.emit(false)
                this.notifys.notify('success', 'Success', "Updated Successfully");
              }, error => {
                this._sharedService.loaderHide.emit(false)
                this.notifys.notify('error', 'Error', error);
              });
            }
            else {
              this._sharedService.loaderHide.emit(true);
              instance.list.modelService.addNew(dialogResult.name, dialogResult).subscribe(
                data => {
                  this._sharedService.loaderHide.emit(false)
                  instance.addAndGet(instance.viewComponent, instance.list.modelService.constructor.name);
                  this.notifys.notify('success', 'Success', "Added Successfully");
                },
                error => {
                  this._sharedService.loaderHide.emit(false)
                  this.notifys.notify('error', 'Error', error);
                }
              )
            }
          }
          else {
            log("Save Aborted By User!!!");
          }
        }
      });
    } catch (e) {
    }
  }
  addAndGet(viewComponent, key) {
    switch (key.toLowerCase()) {
      case "SuiteService".toLowerCase():
        viewComponent.suiteListChange();
        break;
      case "FeatureServiceService".toLowerCase():
        viewComponent.featureListChange();
        break;
      case "ScenarioServiceService".toLowerCase():
        viewComponent.scenarioListChange();
        break;
      case "StepServiceService".toLowerCase():
        viewComponent.stepListChange();
        break;
      default:
        break;
    }
  }

  updateArtifactNameInArtifactAssociations(artifactName, artifactType, artifactId) {
    this.codeLinkageService.updateArtifactNameInAssociationsByArtifactId(artifactId, artifactType, artifactName).subscribe(data => {
      // updatedArtifactName in ArtifactAssociations
    }, error => {
      this.notifys.notify('error', 'Error', error);
    })
  }

  edit(model) {
    this.addModel("Edit ", model)
  }
  delete(model) {
    const message = `Are you sure you want to delete this?`;
    const dialogData = new ConfirmDialogModel("Delete !!!", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this._sharedService.loaderHide.emit(true)

        this.list.modelService.deleteModel(model).subscribe((data) => {
          this.addAndGet(this.viewComponent, this.list.modelService.constructor.name);
          this._sharedService.loaderHide.emit(false)
          this.notifys.notify('warning', 'Deleted', "Deleted successfully ");

        }, error => {
          this._sharedService.loaderHide.emit(false)
          this.notifys.notify('error', 'Error', error);
        });
      }
      else {
        log("Deletion Aborted By User!!!");
        this.notifys.notify('warning', 'Aborted', "Deletion Aborted By User!!!");
      }
    });
  }

  saveAs(model){
    this.addModel("Save As ", model)
  }

  makeNameUniqueInList(name: string, nameList: string[]): string {
    let originalName = name;
    let count = 1;
  
    // Check if the name already exists in the list
    while (nameList.includes(name)) {
      // Append a count at the end of the name
      name = originalName + '_' + count;
      count++;
    }
  
    return name;
  }
}
